import { React, useEffect, useState } from "react";
import ico_handy_orange from "../../../assets/icons/ico_handy_orange.svg";
import ico_huellas_green from "../../../assets/icons/ico_huellas_green.svg";
import ToolsInfoSection from "../../../components/toolsInfoSection";
import ToolsTab from "../../../components/toolsTab";
import VideoBanner from "../../../components/videoBanner";
import img_polilla from "../../../assets/images/img_polilla.png";
import ico_escarabajo from "../../../assets/icons/ico_escarabajo.svg";
import GoToPage from "../../../components/goToPage";
import ToolsActivityButton from "../../../components/toolsActivityButton";
const LightTrapsScreen = ({ handle }) => {
  const [width, setWidth] = useState(window.innerWidth);
  const bosque = "0U8mctMTdwI";

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  useEffect(() => {
    handle(false);
    return () => handle(true);
  }, [handle]);

  return (
    <div className="w-full bg-[#002E0F] h-full overflow-hidden">
      {width > 1279 ? (
        <div>
          <div className="w-full lg:h-[1080px]  absolute">
            <div className="w-full lg:h-[1080px]  absolute bg-black opacity-70"></div>
            <VideoBanner idVideo={bosque}></VideoBanner>
          </div>
          <div className="w-full mx-auto text-white relative h-fit  ">

         <div className=" h-fit absolute right-0 mr-[25rem] -mt-72  z-30 bg-slate-600 w-fit">
           <div className="w-0 h-0 absolute border-blue-50/10 rotate-[40deg] border-b-[1000px] border-r-transparent border-r-[400px] border-l-transparent border-l-[250px]">
           
           </div>
           
         </div>
            <div className="absolute right-0 mt-[40rem] mr-[25rem]">
              <img
                src={img_polilla}
                className="lg:w-[32rem] rotate-[32deg] md:w-[20rem] sm:w-[20rem] w-[20rem] 2xl:visible xl:invisible lg:invisible md:invisible sm:visible visible"
              ></img>
            </div>
            <div className="justify-center text-black h-fit text-left pt-[14rem] relative lg:pl-[8rem] md:pl-[3rem] sm:pl-[3rem] pl-[3rem]">
             <GoToPage
                page="/herramientas"
                side="left"
                name="Atrás"
                fontSizeXL="xl:text-xl"
                fontSizeL="lg:text-lg"
                fontSizeM="md:text-lg"
                fontSizeS="sm:text-base"
                fontSize="text-base"
                textType="font-bold"
                textColor="text-white"
                borderType="border-b-2"
                borderColor="border-white"
                iconSize="h-5"
                iconColor="invert"
                iconMargin="mr-5"
              ></GoToPage>
            </div>
            <div className="grid mb-52 relative lg:pl-32 md:pl-20 sm:pl-10 pl-10 2xl:pr-0 xl:pr-[15rem] lg:pr-[20rem] md:pr-[5rem] sm:pr-[5rem] pr-[5rem] mr-80 2xl:grid-cols-5 xl:grid-cols-1 lg:grid:cols-1 md:grid-cols-1 sm:grid-cols-1 grid-cols-1 2xl:pb-[10rem] xl:pb-[70rem] lg:pb-[70rem] md:pb-[90rem] sm:pb-[90rem] pb-[90rem] min-w-[10rem] pt-10 w-full  ">
              <div className="xl:h-[70rem] col-span-2 lg:h-[75rem] md:h-[75rem] sm:h-full h-full text-black lg:mr-10 bg-white w-full z-10 relative   ">
                <ToolsInfoSection
                  firstIcon={ico_handy_orange}
                  secondIcon={ico_huellas_green}
                  tag="Insectos"
                  title={
                    <h1 className="lg:text-5xl md:text-2xl sm:text-2xl text-2xl lg:px-10 md:px-0 sm:px-0 px-0 lg:text-left md:text-center sm:text-center text-center font-bold  my-10 ">
                      Trampas de luz
                    </h1>
                  }
                  text={
                    <div>
                      <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base pb-5">
                        Las trampas de luz se basan en el efecto que tiene la
                        luz artificial en los insectos voladores. Las luces
                        utilizadas tienen longitudes de onda bajas o
                        ultravioleta, por las que los insectos se ven
                        especialmente atraídos.{" "}
                      </p>
                      <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base pb-5">
                        Este tipo de trampas se componen de una tela blanca sin
                        pegamento, una luz blanca incandescente y una luz negra
                        UV.
                      </p>
                      <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base pb-5">
                        Las trampas de luz se utilizan con frecuencia para el
                        control de plagas, tanto en cultivos como en plantas
                        procesadoras de alimentos. También se utilizan con fines
                        de investigación, a fin de conocer la diversidad de
                        insectos en un bosque.
                      </p>
                      <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base pb-5">
                        Es muy importante tomar en cuenta que estas luces pueden
                        tener un efecto negativo en los insectos, e incluso
                        ocasionar toxicidad lumínica y provocarles la muerte,
                        por lo que no se debe abusar de ellas. La tela blanca
                        sin pegamento tiene el propósito de que los insectos
                        puedan regresar libremente al bosque una vez que las
                        luces se apaguen.
                      </p>
                    </div>
                  }
                ></ToolsInfoSection>
              </div>

              <div className="relative col-span-3 2xl:mt-[13rem] xl:mt-[0rem] lg:mt-[0rem] md:mt-[0rem] sm:mt-[0rem] mt-[0rem]  items-center">
                <div className=" grid relative gap-0">
                  <div className="h-full relative">
                    <img
                      src=""
                      className="w-[50rem] mt-[3.5rem] right-0 absolute z-0 top-0"
                    ></img>
                    <div className="h-44 w-full bg-[#F77E0B] relative 2xl:mt-[25.6rem] xl:mt-0 md:mt-0 sm:mt-0 mt-0 pl-20">
                      <div className="grid grid-cols-2 grid-rows-1 relative text-white">
                        <div className="inline-flex items-center py-5 ml-10">
                          <img loading="lazy" src={ico_escarabajo}></img>
                          <label className="ml-5 text-2xl font-bold">
                            Insectos
                          </label>
                        </div>
                        <p className="py-16 text-lg">
                          Atrae insectos como polillas nocturnas, <br />{" "}
                          escarabajos y otros insectos voladores.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="relative w-full h-full items-center  text-white bg-[#002E0F] pr-10 pt-5">
                    <ToolsTab
                    firstTitle="Bosques y fragmentos de bosques"
                    secondTitle="Resultados y beneficios"
                      firstTab={
                        <div>
                          <p className="text-xl mb-5">
                          Se deben colocar en zonas abiertas, en bordes de bosques o fragmentos de bosque, de manera tal que ese espacio abierto permita que la luz sea observada y atraiga la mayor cantidad de insectos posible.
                          </p>
                          <p className="text-xl mb-5">
                            Para fines de investigación y monitoreo de insectos,
                            lo más recomendable es colocarla durante la luna
                            nueva.
                          </p>
                          <p className="text-xl mb-5">
                            Las luces de la trampa pueden encenderse con el
                            atardecer y permanecer encendidas hasta la
                            madrugada.
                          </p>
                        </div>
                      }
                      secondTab={
                        <div>
                          <p className="text-xl mb-5">
                            Permite conocer al menos una parte de la diversidad
                            de insectos presente en un sitio, lo cual también
                            puede ser un indicador de la calidad del hábitat que
                            se está monitoreando.
                          </p>
                          <p className="text-xl mb-5">
                            Permite observar con detenimiento los insectos.
                          </p>
                          <p className="text-xl mb-5">
                            Es una excelente herramienta para acercar a las
                            personas a la riqueza de un grupo poco conocido como
                            los insectos.
                          </p>
                        </div>
                      }
                    ></ToolsTab>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div className="w-full absolute overflow-hidden">
            <div className="w-full h-full absolute  bg-black opacity-70">
              <p>PRUEBA</p>
            </div>
            <VideoBanner idVideo={bosque}></VideoBanner>
            <div className=" absolute right-0 bottom-0 lg:mb-24 md:mb-14 sm:mb-5 mb-5 lg:mr-[30rem] md:mr-[20rem] sm:mr-40 mr-40 ">
              <img
                loading="lazy"
                src={img_polilla}
                className="lg:w-[25rem] md:w-[15rem] sm:w-[10rem] w-[10rem] rotate-[35deg]"
              ></img>
            </div>
            
          </div>
          <div className=" h-fit absolute right-0 mr-[9rem] -mt-20  z-30 bg-slate-600 w-fit">
           <div className="w-0 h-0 absolute border-blue-50/10 rotate-[40deg] border-b-[250px] border-r-transparent border-r-[70px] border-l-transparent border-l-[100px]">
           
           </div>
           
         </div>

          <div className="grid grid-cols-1  2xl:px-52  lg:px-30 md:px-10 sm:px-14 px-10 pb-[40rem]">
            <div className="justify-center text-black h-fit text-left lg:mt-[25rem] md:mt-[15rem] sm:mt-[7rem] mt-[7rem] relative ">
             <GoToPage
                page="/herramientas"
                side="left"
                name="Atrás"
                fontSizeXL="xl:text-xl"
                fontSizeL="lg:text-lg"
                fontSizeM="md:text-lg"
                fontSizeS="sm:text-base"
                fontSize="text-base"
                textType="font-bold"
                textColor="text-white"
                borderType="border-b-2"
                borderColor="border-white"
                iconSize="h-5"
                iconColor="invert"
                iconMargin="mr-5"
              ></GoToPage>
            </div>

            <div className=" h-fit text-black  bg-white w-full z-10 relative bottom-0  mt-[4rem]  ">
              <ToolsInfoSection
                firstIcon={ico_handy_orange}
                secondIcon={ico_huellas_green}
                tag="Insectos"
                title={
                  <h1 className="lg:text-5xl md:text-2xl sm:text-2xl text-2xl lg:px-10 md:px-0 sm:px-0 px-0 lg:text-left md:text-center sm:text-center text-center font-bold  my-10 ">
                    Trampa de luz
                  </h1>
                }
                text={
                  <div>
                    <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base pb-5">
                      Las trampas de luz se basan en el efecto que tiene la luz
                      artificial en los insectos voladores. Las luces utilizadas
                      tienen longitudes de onda bajas o ultravioleta, por las
                      que los insectos se ven especialmente atraídos.{" "}
                    </p>
                    <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base pb-5">
                      Este tipo de trampas se componen de una tela blanca sin
                      pegamento, una luz blanca incandescente y una luz negra
                      UV.
                    </p>
                    <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base pb-5">
                      Las trampas de luz se utilizan con frecuencia para el
                      control de plagas, tanto en cultivos como en plantas
                      procesadoras de alimentos. También se utilizan con fines
                      de investigación, a fin de conocer la diversidad de
                      insectos en un bosque.
                    </p>
                    <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base lg:mb-32 md:mb-14 sm:pb-32 pb-32">
                      Es muy importante tomar en cuenta que estas luces pueden
                      tener un efecto negativo en los insectos, e incluso
                      ocasionar toxicidad lumínica y provocarles la muerte, por
                      lo que no se debe abusar de ellas. La tela blanca sin
                      pegamento tiene el propósito de que los insectos puedan
                      regresar libremente al bosque una vez que las luces se
                      apaguen.
                    </p>
                  </div>
                }
              ></ToolsInfoSection>
            </div>
            <div className="relative w-full h-full items-center lg:mt-32 md:mt-10 sm:mt-5 mt-5  text-white bg-[#002E0F]">
              <ToolsTab
              firstTitle="Bosques y fragmentos de bosques"
              secondTitle="Resultados y beneficios"
                firstTab={
                  <div>
                    <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                    Se deben colocar en zonas abiertas, en bordes de bosques o fragmentos de bosque, de manera tal que ese espacio abierto permita que la luz sea observada y atraiga la mayor cantidad de insectos posible.
                    </p>
                    <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                      Para fines de investigación y monitoreo de insectos, lo
                      más recomendable es colocarla durante la luna nueva.
                    </p>
                    <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                      Las luces de la trampa pueden encenderse con el atardecer
                      y permanecer encendidas hasta la madrugada.
                    </p>
                  </div>
                }
                secondTab={
                  <div>
                    <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                      Permite conocer al menos una parte de la diversidad de
                      insectos presente en un sitio, lo cual también puede ser
                      un indicador de la calidad del hábitat que se está
                      monitoreando.
                    </p>
                    <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                      Permite observar con detenimiento los insectos.
                    </p>
                    <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                      Es una excelente herramienta para acercar a las personas a
                      la riqueza de un grupo poco conocido como los insectos.
                    </p>
                  </div>
                }
              ></ToolsTab>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LightTrapsScreen;
